import Image from 'next/image'
import { useEffect, useState } from 'react'
import clsx from 'clsx'

import { Icon } from '@wartek-id/icon-v2'
import { Shimmer } from '@wartek-id/shimmer'
import { Text } from '@wartek-id/text-v1'

import { getIndicatorIllustrationPath } from 'app/KinerjaPage/pages/PelaksanaanV2/utils/indicator'
import { RubrikObservasiDialog } from './RubrikObservasiDialog'

export function IndicatorCard({
  illustrationAssetPath = '',
  className = '',
  subIndicatorName,
  subIndicatorDefinition,
  qualityTarget,
  contentId,
  isLoading = false,
  onRubrikDialogOpened = () => {},
  onRubrikDialogClosed = () => {},
}) {
  const [dialogOpen, setDialogOpen] = useState(false)

  useEffect(() => {
    if (dialogOpen) {
      onRubrikDialogOpened()
    }
  }, [dialogOpen, onRubrikDialogOpened])

  return (
    <div
      className={clsx(
        'flex space-x-4 border border-solid rounded-lg p-4 max-w-4xl border-subdued',
        className
      )}
    >
      <div className="flex space-x-4 max-w-md w-full">
        <div className="w-20 h-20 items-center flex">
          {isLoading ? (
            <Shimmer width={84} height={84} />
          ) : (
            <Image
              width={84}
              height={84}
              src={
                illustrationAssetPath ||
                getIndicatorIllustrationPath(subIndicatorName)
              }
              alt=""
            />
          )}
        </div>
        <div className="w-full space-y-1">
          <Text color="subdued" variant="body-sm">
            Indikator pilihan:
          </Text>
          {isLoading ? (
            <Shimmer className="!h-6 !w-full" />
          ) : (
            <Text variant="action" className="overflow-wrap-anywhere">
              {subIndicatorName}
            </Text>
          )}
          <button
            type="button"
            className="flex items-center cursor-pointer"
            aria-haspopup={true}
            aria-expanded={dialogOpen}
            onClick={() => {
              setDialogOpen(true)
            }}
          >
            <Text color="primary" variant="body-sm-bold">
              Cek Rubrik Observasi
            </Text>
            <Icon color="informational">chevron_right</Icon>
          </button>
        </div>
      </div>

      <div className="max-w-md w-full">
        <Text color="subdued" variant="body-sm">
          Praktiknya dilihat dari:
        </Text>

        {isLoading ? (
          <div className="space-y-1 w-full">
            <Shimmer noOfLines={3} className="!w-full" />
          </div>
        ) : (
          <Text variant="body-sm" className="overflow-wrap-anywhere">
            {qualityTarget}
          </Text>
        )}
      </div>

      <RubrikObservasiDialog
        isOpen={dialogOpen}
        onClose={() => {
          onRubrikDialogClosed()
          setDialogOpen(false)
        }}
        illustrationAssetPath={illustrationAssetPath}
        contentId={contentId}
        indicator={subIndicatorName}
        definition={subIndicatorDefinition}
        isLoadingIndicator={isLoading}
      />
    </div>
  )
}
